import React, { useState } from 'react';
import cx from "classnames";

import { BusinessDirectoryAdBannerFragmentParameter } from "@/app/pages/companyProfile/businessDirectoryAdBanner/interfaces";
import { isNotUndefined, unitedStatesIsoCode } from "@/shared/FunctionCore";
import "@/app/pages/companyProfile/businessDirectoryAdBanner/businessDirectoryAdBanner.scss"


const BusinessDirectoryAdBannerComponent = (props: any): JSX.Element => {
    const {
        adBannerDetailTextOne,
        adBannerDetailTextTwo,
        adBannerDisclaimerText,
        adBannerSubtitle,
        adBannerTitle,
        cartCheckoutPath,
        ctaLabel,
        ctaLink,
        dnbCartApiKey,
        dnbCartTokenValue,
        formIdentifier,
        linkCartButtonText,
        linkCartPrice,
        linkProductId,
        localeLanguageTag,
        priceLabel,
        quantity,
        selectedPriceId,
        uniqueId
    } = props.properties;
    const {companyHeaderData, countryCode : countryIsoCode} = props;
    const {companyName, companyNewHeaderParameter } = companyHeaderData;
    const { companyInformationForCookie} = companyNewHeaderParameter;
    const [accordianOpen, setAccordianOpen] = useState(false);

    return (
        <>
            {companyInformationForCookie["companyCountry"] === unitedStatesIsoCode ? (<div
                className={"business-directory-redesign-container-ad-banner business-directory-ad-banner-container"}
                id="bir-snapshot-ad-banner">
                <div className="ad-banner-wrapper col-xs-12">
                    <div className={"ad-banner-heading-wrapper row"}>
                        <div className='row-accordian'>
                            <h3>
                                <p className={"ad-banner-title"}>
                                    {adBannerTitle}

                                    {companyName}
                                    ?
                                </p>
                            </h3>

                            <p onClick={() => setAccordianOpen(!accordianOpen)} className={`${accordianOpen ? 'learn-more-SS active' : 'learn-more-SS '} `}>
                                Learn More
                            </p>
                        </div>
                        
                        {accordianOpen &&
                            <>
                                <p className={`ad-banner-subtitle `}>
                                    {adBannerSubtitle}
                                </p>
                                <div className={"col-md-8 col-xs-12"}>
                                    <div>
                                        <ul>
                                            <li className={"ad-banner-detail-text"}>
                                                {adBannerDetailTextOne}
                                            </li>

                                            <li
                                                className={"ad-banner-detail-text"}
                                                dangerouslySetInnerHTML={{ "__html": adBannerDetailTextTwo ?? "" }} />
                                        </ul>
                                    </div>

                                    <div>
                                        {
                                            isNotUndefined(adBannerDisclaimerText) && adBannerDisclaimerText.length > 0
                                                ? <p className={"ad-banner-disclaimer-text"}>
                                                    {adBannerDisclaimerText}
                                                </p>
                                                : ""
                                        }
                                    </div>
                                </div>

                                <div className={cx("col-md-4", "col-xs-12")}>
                                    <div
                                        className={"price-block"}
                                        id="price-block">
                                        {
                                            isNotUndefined(priceLabel) && priceLabel.length > 0
                                                ?
                                                <h4 className={"price-text"}>
                                                    {priceLabel}
                                                </h4>
                                                : ""
                                        }

                                        <div className="cta">
                                            <div className={"cta-cart"}>
                                                <form
                                                    action={cartCheckoutPath}
                                                    className={"form-inline cart"}
                                                    id={formIdentifier}
                                                    method="post"
                                                    name={formIdentifier}
                                                    style={{ "display": "inline-block" }}>
                                                    <input
                                                        name="productId"
                                                        type="hidden"
                                                        value={linkProductId} />

                                                    <input
                                                        name="priceId"
                                                        type="hidden"
                                                        value={selectedPriceId} />

                                                    <input
                                                        className="duns_number"
                                                        name="dunsNumber"
                                                        type="hidden"
                                                        value="" />

                                                    <input
                                                        name="_token"
                                                        type="hidden"
                                                        value={dnbCartTokenValue} />

                                                    <input
                                                        name="unique_id"
                                                        type="hidden"
                                                        value={uniqueId} />

                                                    <input
                                                        name="api_key"
                                                        type="hidden"
                                                        value={dnbCartApiKey} />

                                                    <input
                                                        name="quantity"
                                                        type="hidden"
                                                        value={quantity} />

                                                    <input
                                                        name="locale"
                                                        type="hidden"
                                                        value={localeLanguageTag} />

                                                    <input
                                                        name="price"
                                                        type="hidden"
                                                        value={linkCartPrice} />

                                                    <input
                                                        className="field  mktg_optimization_id hidden"
                                                        id="optimization_id"
                                                        name="MKTG_Optimization_ID__c"
                                                        type="hidden"
                                                        value="" />

                                                    <input
                                                        className={"field business_directory_industry hidden"}
                                                        id="directory_industry"
                                                        name="Business_Directory_Industry__c"
                                                        type="hidden"
                                                        value="" />

                                                    <input
                                                        className={"button-primary no-outline add-to-cart-button ad-banner-submit-cta"}
                                                        // onClick={(cl) => trackCartEvents(cl.currentTarget)}
                                                        type="submit"
                                                        value={linkCartButtonText}
                                                    />
                                                </form>
                                            </div>
                                        </div>
                                    </div>

                                    <a
                                        className={"ad-banner-cta"}
                                        href={ctaLink}
                                        // onClick={() => track_event("ad_banner_view_more_details_clicked")}
                                    >
                                        <span className={"cta-right button-view v1 arrow-right"}>
                                            {ctaLabel}
                                        </span>

                                        <span className={"rightArrowBlueThin"} />
                                    </a>
                                </div>
                            </>
                        }

                    </div>
                </div>
            </div>) : null}

        </>)

};



export default BusinessDirectoryAdBannerComponent;